import * as React from 'react';
import CallToActionHeading from '../components/CallToActionHeading';
import CareersBlurb from '../components/CareersBlurb';
import JobPosts from '../components/JobPosts';
import Layout from '../components/Layout';
import Logos from '../components/Logos';
import MediaBlock from '../components/MediaBlock';
import ScreenFrame from '../components/ScreenFrame';
import SEO from '../components/SEO';
import Video from '../components/Video';
import { colors } from '../constants';

const Careers: React.FunctionComponent = () => (
  <Layout color="medium">
    <SEO
      title="Join Raydiant - Raydiant Careers"
      description="Join a fast-growing tech startup that is inventing the future of brick-and-mortar."
      keywords="Raydiant, digital signage, screen signage, careers"
    />
    <MediaBlock
      color="medium"
      flex={1.5}
      aspectRatio={[16, 9]}
      paddingTopSm
      paddingBottom
      paddingRight
      paddingLeft
      media={
        <ScreenFrame>
          <Video
            loop
            backgroundColor={colors.black}
            sources={[
              {
                src: require('../assets/videos/careers.mp4'),
                type: 'video/mp4',
              },
            ]}
          />
        </ScreenFrame>
      }
    >
      <CallToActionHeading
        heading={
          <span>
            Dear rule-breakers,
            <br /> difference-makers,
            <br /> and questioners:
            <br /> We want you!
          </span>
        }
        headingColor={colors.white}
        bodyColor={colors.white}
        headingType="h1"
      />
    </MediaBlock>

    <CareersBlurb />

    <JobPosts />

    <Logos logoColor={colors.skyBlue} />
  </Layout>
);

export default Careers;
